import { styled, Tabs } from "@mui/material";

export const AttributeTabsCustom = styled(Tabs)(() => ({
  display: "flex",
  flexDirection: "row",
  maxWidth: "100%",
  padding: "1rem 0rem",
  "> .Mui-disabled": {
    display: "none"
  },
  fontWeight: "500"
}));

